import { createContext } from 'react';

export const LibraryContext = createContext<{
  disableExternalLinkModal?: boolean;
  reportError: typeof console.error;
}>({
  // eslint-disable-next-line no-console
  reportError: console.error,
});
